<div class="coupon-status" *transloco="let t">
    <div class="loading-container"
    *ngIf="loading">
      <mat-spinner
      [diameter]="60"
      class="spinner"></mat-spinner>
    </div>
    <div class="header-status">
        <div>{{this.labels.couponStatusText}}</div>
        <button (click)="clickClose()" mat-icon-button class="close-button" id="close-coupon-status-click">
            <mat-icon>cancel</mat-icon>
          </button>
    </div>
    <div class="body-status">
        <div class="chip-container">
            <div class="chip" id="coupon-status-used-chip" (click)="selectChip('USED')" ngClass="{{selected === 'USED' ? 'selected' : ''}}">
                <mat-icon>check_circle</mat-icon>
                <div>{{this.labels.redeemed}}</div>
            </div>        
            <div *ngIf="this.isShowCancel()" class="chip" id="coupon-status-canceled-chip" (click)="selectChip('CANCELED')" ngClass="{{selected === 'CANCELED' ? 'selected' : ''}}">
                <mat-icon>cancel</mat-icon>
                <div>{{this.labels.canceled}}</div>
            </div>
        </div>
        <div class="content-status">
            <div *ngIf="this.selected === 'USED'">
                <app-input [label]="labels.formDate" [datepicker]="redemptionDate" [minDate]="minDate" [maxDate]="maxDate" [fontSize]="'12px'" [control]="this.form.controls.date"></app-input>
                <app-input [label]="labels.formInvoice + '#'" [fontSize]="'12px'" [prefix]="'#'" [control]="this.form.controls.invoice"></app-input>
                <app-input [label]="labels.formValue" [fontSize]="'12px'" [prefix]="'U$'" [control]="this.form.controls.discount" [mask]="'separator.2'" [separator]="separator"></app-input>
                <app-input [label]="labels.formReseller" [fontSize]="'12px'" [control]="this.form.controls.reseller"></app-input>
                <mat-datepicker #redemptionDate></mat-datepicker>
                <app-checkbox [formGroup]="form" abstractFormControlName="acknowledge">{{t('acknowledge-redeem-coupon')}}</app-checkbox>                
            </div>
            <div *ngIf="this.selected === 'CANCELED'">
              <span>{{this.labels.textCancel}}</span>
              <span class="bold-info">{{this.labels.textCancelBold}}</span>
              <div class="points-info">
                <div class="active-points">
                  <div>
                    <span class="status-label">{{this.labels.activePoints}}</span>
                    <div class="active-points-number">
                      <app-sticker-icon class="stars" small icon="stars">
                        <div>{{couponData.activePoints | number}}</div>
                      </app-sticker-icon>
                    </div>
                  </div>
                </div>
                <div class="expired-points">
                  <div>
                    <span class="status-label">{{this.labels.expiredPoints}}</span>
                    <div class="expired-points-number">
                      <app-sticker-icon class="stars coupon-star" small icon="stars">
                        <div>{{couponData.expiredPoints | number}}</div>
                      </app-sticker-icon>
                    </div>
                  </div>
                </div>
              </div>
              <app-checkbox [formGroup]="form" abstractFormControlName="acknowledge">{{t('acknowledge-cancel-coupon')}}</app-checkbox>                
            </div>
        </div>
    </div>
    <div class="footer-status">
        <button id ="coupon-status-change-status-button" class="change-status-button" [ngClass]="{'active': !disabled()}" mat-raised-button color="primary" [disabled]="disabled() && selected" (click)="changeStatus()">{{this.labels.changeStatus}}</button>
        <button id ="coupon-status-close-button" mat-flat-button color="primary" (click)="clickClose()">{{this.labels.cancel}}</button>
    </div>
</div>
